import { Components, Theme } from '@mui/material'

const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: 0,
      width: 24,
      height: 24,
      background: theme.backgrounds.backgroundFour,
      border: `1px solid ${theme.backgrounds.backgroundOne}`,
      boxShadow: theme.boxShadows.small,
      borderRadius: 8,

      '&.MuiButtonBase-root': {
        '&.MuiButtonBase-root': {
          color: theme.colors.empty,
          fontSize: 'inherit',
          '.MuiSvgIcon-root': {
            fontSize: 'inherit',
          },
        },
      },
      '&.Mui-checked': {
        border: `4px solid ${theme.colors.green}`,

        '&.MuiButtonBase-root': {
          '.MuiSvgIcon-root': {
            width: 24,
            height: 24,
            borderRadius: 8,
            color: theme.colors.green,
          },
        },
      },

      '&.Mui-disabled': {
        '&.MuiButtonBase-root': {
          background: theme.colors.grayHover,
        },
        '&.Mui-checked': {
          '&.MuiButtonBase-root': {
            opacity: 0.5,
          },
        },
      },
    }),
  },
}

export default MuiCheckbox
